import { render, staticRenderFns } from "./SAASDialog.vue?vue&type=template&id=0847926c"
import script from "./SAASDialog.vue?vue&type=script&lang=js"
export * from "./SAASDialog.vue?vue&type=script&lang=js"
import style0 from "./SAASDialog.vue?vue&type=style&index=0&id=0847926c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports